import {
  permissions,
} from '@/config/config'

export default function (permissionName, userPermissions) {
  return userPermissions.find(permission => permission.name === permissions[permissionName])
}
